import React from "react";
import { Button } from "primereact/button";

const MyButton1 = ({ title = "Button", method = () => {},marginLeft, fontSize = "14px",padding="",disabled = false, icon = null }) => {
  return (
     <button 
    onClick={method}
    disabled={disabled} 
  className="custom-buttom-home-button"
  style={{fontSize,padding,marginLeft}}
  >
    
      {title}
    </button>
  );
};

export default MyButton1;
